// extracted by mini-css-extract-plugin
export default {"commonTitle":"avMNK8Qg8S6ELvNBn4SS","commonContent":"nt3HkYGHVSEvaGFFn12x","valueHighlight":"IaB7qowESm87OGdl_B_p","common_bganimation":"sM5S7yl96U5n5iEVTxxw"};